"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SendButton_1 = require("../buttons/SendButton");
const react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
const utils_1 = require("../../../../services/utils");
const LongTextInput = ({ onSubmit, placeholder, buttonLabel, isRequired, }) => {
    const inputRef = (0, react_1.useRef)(null);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (!inputRef.current || (0, utils_1.isMobile)() || !document.hasFocus())
            return;
        inputRef.current.focus();
    });
    return (react_1.default.createElement("div", { className: "flex flex-col w-full lg:w-4/6" },
        react_1.default.createElement("div", { className: "flex items-center" },
            react_1.default.createElement("form", { className: "flex items-end justify-between rounded-lg typebot-input", onSubmit: (e) => {
                    e.preventDefault();
                    if (isRequired && inputValue === "")
                        return;
                    onSubmit(inputValue);
                } },
                react_1.default.createElement(react_textarea_autosize_1.default, { ref: inputRef, className: "focus:outline-none bg-transparent px-4 py-4 flex-1 comp-input", placeholder: placeholder, onChange: (e) => setInputValue(e.target.value), maxRows: 8, minRows: 2 }),
                react_1.default.createElement(SendButton_1.SendButton, { className: "mx-2 mb-2", label: buttonLabel, isDisabled: isRequired && inputValue === "" })))));
};
exports.default = LongTextInput;
//# sourceMappingURL=LongTextInput.js.map